export default __webpack_public_path__ + "static/media/PT-Root-UI_Bold.3028ce78.woff";